function cdpActiveIndex(scrollLeft, stride, count) {
  if (!stride || count < 1) return 0;
  var index = Math.round(scrollLeft / stride);
  if (index <= 0) return 0;
  if (index > count - 1) return count - 1;
  return index;
}

function cdpPageCount(maxScroll, stride, cardCount) {
  if (cardCount < 1) return 1;
  if (!stride || maxScroll <= 0) return 1;
  return cdpActiveIndex(maxScroll, stride, cardCount) + 1;
}

function cdpScrollLeft(pageIndex, stride, maxScroll) {
  var left = Math.max(0, pageIndex) * (stride || 0);
  if (left > maxScroll) return maxScroll;
  return left;
}

(function () {
    var root = document.querySelector('[data-content-depth]');
    if (!root) return;

    var scroller = root.querySelector('[data-cdp-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cdp-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cdp-dot]'));
    var prev = root.querySelector('[data-cdp-prev]');
    var next = root.querySelector('[data-cdp-next]');
    if (!scroller || !cards.length) return;

    function stride() {
      if (cards.length < 2) return cards[0].getBoundingClientRect().width;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function limits() {
      var step = stride();
      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      return { step: step, max: max, pages: cdpPageCount(max, step, cards.length) };
    }

    function current() {
      var box = limits();
      return cdpActiveIndex(scroller.scrollLeft, box.step, box.pages);
    }

    function paint() {
      var box = limits();
      var index = current();
      dots.forEach(function (dot, i) {
        var show = i < box.pages;
        dot.hidden = !show;
        var on = show && i === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
        if (show) dot.setAttribute('aria-label', 'Page ' + (i + 1));
      });
    }

    function go(index) {
      var box = limits();
      if (!box.step) return;
      scroller.scrollTo({
        left: cdpScrollLeft(index, box.step, box.max),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });
    scroller.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) paint();
      });
      observer.observe(root);
    }
    paint();
})();
